var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mass-control-manage"},[_vm._v(" 群防群治管理 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }